// ─── utils/push.js ───────────────────────────────────────────────────────────
// Turning on phone/desktop alerts (server: services/push.js). The service
// worker (public/sw.js) is only registered when someone opts in.
// iPhone only offers Web Push to a site added to the Home Screen (iOS 16.4+).

export const pushSupported = () => typeof window !== 'undefined'
  && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

export async function pushKey() {
  try {
    const res = await fetch('/api/notifications/push/key');
    return res.ok ? (await res.json()).key || '' : '';
  } catch {
    return '';
  }
}

const toBytes = (b64) => {
  const s = atob((b64 + '='.repeat((4 - (b64.length % 4)) % 4)).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from(s, (c) => c.charCodeAt(0));
};

// Asks the browser, subscribes, and saves it. Resolves to 'on', 'denied' or 'error'.
export async function enablePush(key) {
  try {
    if ((await Notification.requestPermission()) !== 'granted') return 'denied';
    const reg = await navigator.serviceWorker.register('/sw.js');
    await navigator.serviceWorker.ready;
    const sub = (await reg.pushManager.getSubscription())
      || await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toBytes(key) });
    const res = await fetch('/api/notifications/push/subscribe', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ subscription: sub.toJSON() }),
    });
    return res.ok ? 'on' : 'error';
  } catch {
    return 'error';
  }
}

// On sign-out: stop this device getting the account's alerts. Best-effort;
// never holds up the sign-out itself.
export async function disablePushOnThisDevice() {
  try {
    if (!pushSupported()) return;
    const reg = await navigator.serviceWorker.getRegistration('/sw.js');
    const sub = reg && await reg.pushManager.getSubscription();
    if (!sub) return;
    await fetch('/api/notifications/push/unsubscribe', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ endpoint: sub.endpoint }),
    });
    await sub.unsubscribe();
  } catch { /* nothing to undo */ }
}
